<template>
  <pt-lab-product-table class="pt-lab-product-table__withData" @getTableData="getTableData" :tableData="tableData" :totalNumber="totalNumber" :selectType="selectType" :selectedKeys="selectedKeys" @selection-change="handleSelectionChange" ref="tableIndex" :isOutside="isOutside" v-on="$listeners" :isDialog="isDialog" :pageSize="pageSize" :isAddPageToRouter="!isDialog">
  </pt-lab-product-table>
</template>

<script>
import PtLabProductTable from './index'
export default {
  name: 'pt-lab-product-table__withData',
  components: {
    'pt-lab-product-table': PtLabProductTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: String,
      default: ''
    },
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    isDialog: Boolean,
    productList: Array,
    noQuery: Boolean // 无需请求接口
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.tableIndex.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getTableData(0)
          this.$refs.tableIndex.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    handleSelectionChange (val) {
      this.$emit('selection-change', val)
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        example: {
          organizationRole: 'LAB',
          ...this.paramsData
        },
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      this.$store.dispatch('getLabProductList', data).then(res => {
        console.log('noQuery=', this.noQuery)
        this.tableData = this.noQuery ? this.productList : res.data
        this.totalNumber = this.noQuery ? this.productList.length : res.totalNumber
        if (next) {
          next(this.tableData)
        }
      }).catch(err => {
        this.$refs.tableIndex.showReTry()
        this.$message.error(err || '获取实验室产品列表失败')
      })
    },
    load () {
      // this.$nextTick(_ => {
      this.$refs.tableIndex.load()
      // })
    }
  }
}
</script>
